/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Lots_Search_LabelInputs */

const vi_pkl_lots_search_label = /** @type {(inputs: Pkl_Lots_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo mã lô hoặc tên vật tư`)
};

/**

* @param {Pkl_Lots_Search_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_lots_search_label = /** @type {((inputs?: Pkl_Lots_Search_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Lots_Search_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_lots_search_label(inputs)
});